import SendMail from "./SendMail"

const handleFailedHubSpotSubmission = async (data = {}) => {
  if (!data) return
  let fields = []

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      try {
        fields.push({
          label: key
            .replaceAll("_", " ")
            .replace(/\b\w/g, (l) => l.toUpperCase()),
          value: data[key],
        })
      } catch (e) {
        fields.push({
          label: key,
          value: data[key],
        })
      }
    }
  }
  const formData = {
    toEmail:
      process.env.GATSBY_FAILED_HUBSPOT_EMAILS ||
      "mahesh.samudra@worksimply.com",
    formData: fields,
  }

  await SendMail(
    formData,
    null,
    "Failed to submit form to HubSpot",
    "Failed to submit form to HubSpot"
  )
  console.log("Notified the HS submission")
  return true
}

export default handleFailedHubSpotSubmission
